import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Canonical host enforcement: www -> non-www (safety net for server-level 301)
if (window.location.hostname.startsWith("www.")) {
  const target =
    window.location.protocol +
    "//" +
    window.location.hostname.slice(4) +
    window.location.pathname +
    window.location.search +
    window.location.hash;
  window.location.replace(target);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
